require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-g-cn-un.json") })
        }
      }, "path---photos-professional-g-cn-un");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-g-cn-un!./.cache/json/photos-professional-g-cn-un.json
// module id = 752
// module chunks = 231608221292675